import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../../helper/helper';

export interface SelectWarehouseMovementTypeDialogComponentDialogData {}
export type SelectWarehouseMovementTypeDialogComponentDialogReturnData = 'in' | 'out' | undefined;

@Component({
    selector: 'app-select-warehouse-movement-type-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, AppButtonModule, FontAwesomeModule],
    templateUrl: './select-warehouse-movement-type-dialog.component.html',
    styleUrls: ['./select-warehouse-movement-type-dialog.component.scss'],
})
export class SelectWarehouseMovementTypeDialogComponent  {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
    };
    constructor() {}

}
